<div class="row flex-1 justify-content-center">
  <div class="col-12 col-md-8 col-lg-6">
    <cx-spinner class="overlay" *ngIf="isUpdating$ | async"></cx-spinner>

    <page-title></page-title>

    <form (ngSubmit)="onSubmit()" [formGroup]="form" class="m-t-20">
      <label>
        <span class="label-content">
          {{ 'loginForm.emailAddress.label' | cxTranslate }}
          <ng-template [ngTemplateOutlet]="requiredAsterisk"></ng-template>
        </span>

        <input
          required="true"
          type="email"
          class="form-control"
          formControlName="userId"
          placeholder="{{ 'loginForm.emailAddress.placeholder' | cxTranslate }}"
        />
        <cx-form-errors [control]="form.get('userId')"></cx-form-errors>
      </label>

      <label>
        <span class="label-content">
          {{ 'loginForm.password.label' | cxTranslate }}
          <ng-template [ngTemplateOutlet]="requiredAsterisk"></ng-template>
        </span>

        <div class="container-icon">
          <input
            #pw
            required="true"
            type="password"
            class="form-control"
            placeholder="{{ 'loginForm.password.placeholder' | cxTranslate }}"
            formControlName="password"
            [attr.aria-label]="'loginForm.password.placeholder' | cxTranslate"
          />

          <btn-visibility (statusChange)="setInputType($event, pw)"></btn-visibility>
        </div>
        <cx-form-errors [control]="form.get('password')"></cx-form-errors>
      </label>

      <a [routerLink]="{ cxRoute: 'forgotPassword' } | cxUrl" class="btn-link d-block w-100">
        {{ 'loginForm.forgotPassword' | cxTranslate }}
      </a>

      <div class="d-block w-100 m-t-20">
        <div class="row justify-content-between m-t--20">
          <div class="col-12 col-lg-4 m-t-20">
            <a [routerLink]="['/login/register']" class="btn btn-block btn-outline-primary w-100 m-0">
              {{ 'loginForm.register' | cxTranslate }}
            </a>
          </div>

          <div class="col-12 col-lg-4 m-t-20">
            <button type="submit" class="btn btn-block btn-primary w-100 m-0" [disabled]="form.disabled">
              {{ 'loginForm.signIn' | cxTranslate }}
            </button>
          </div>
        </div>
      </div>
    </form>

    <ng-template #requiredAsterisk>
      <abbr *cxFeature="'a11yRequiredAsterisks'" class="text-decoration-none" title="{{ 'common.required' | cxTranslate }}">*</abbr>
    </ng-template>
  </div>
</div>
